import { LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { StorageMap, StorageModule } from '@ngx-pwa/local-storage';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { HttpConfigInterceptor } from './interceptors/http.interceptor';
import { AlertToastComponent } from './components/alert-toast/alert-toast.component';

import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeZh from '@angular/common/locales/zh';
import localRu from '@angular/common/locales/ru';
import localUk from '@angular/common/locales/uk';
import localEs from '@angular/common/locales/es';
import localDe from '@angular/common/locales/de';
import localIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';

// Enregistrer les locales
registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localeZh);
registerLocaleData(localRu);
registerLocaleData(localUk);
registerLocaleData(localEs);
registerLocaleData(localDe);
registerLocaleData(localIt);

// Factory pour TranslateHttpLoader
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export const appConfig = {
  providers: [
    // Router avec preloading
    provideRouter(
      routes,
      withPreloading(PreloadAllModules)
    ),

    // HTTP Client avec intercepteur (withInterceptorsFromDi permet l'utilisation des class-based interceptors)
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },

    // Animations
    provideAnimations(),

    // Locale
    {
      provide: LOCALE_ID,
      useValue: 'fr-FR',
    },

    // Toastr
    provideToastr({
      toastComponent: AlertToastComponent,
    }),

    // Device Detector
    DeviceDetectorService,

    // Modules à importer (pour les services qui utilisent forRoot)
    importProvidersFrom(
      NgbModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      StorageModule.forRoot({
        IDBDBName: 'gs',
        LSPrefix: 'app_'
      }),
      NgCircleProgressModule.forRoot({
        radius: 60,
        space: -10,
        outerStrokeGradient: true,
        outerStrokeWidth: 10,
        outerStrokeColor: '#4882c2',
        outerStrokeGradientStopColor: '#53a9ff',
        innerStrokeColor: '#e7e8ea',
        innerStrokeWidth: 10,
        title: 'UI',
        animateTitle: false,
        animationDuration: 1000,
        showTitle: false,
        showUnits: false,
        showBackground: false,
        clockwise: false,
        responsive: true,
        lazy: true
      }),
    )
  ],
};
